import { tokens } from '@env0/ui-theme';

/**
 * Both switch states carry the same values: today's radii and spacings are per-site literals with no
 * ladder to map onto. `scale` is the base ladder the others alias; prefer the semantic names.
 *
 * Its own module rather than themes.constants: that file imports the legacy themes, so importing a
 * *value* back from it forms a cycle whose losing side spreads an uninitialised binding — legal JS,
 * silently dropping every key.
 */
export const sharedPrimitives = {
  scale: tokens.spacing.scale,
  spacing: tokens.spacing.spacing,
  padding: tokens.spacing.padding,
  radius: tokens.spacing.radius,
  borderWidth: tokens.spacing.borderWidth,
  zIndex: tokens.zIndex,
  shadows: tokens.shadows
} as const;

export type DesignPrimitives = typeof sharedPrimitives;

/**
 * antd 5.6.4's own ladder, which the app renders on today. Figma's numbers are MUI's (md 900) and its
 * descriptions mark them PROVISIONAL, so the new-design side holds these too until design decides
 * (APO-455 D4) — adopting md 900 moves the mobile boundary for 45 `isMobile` reads, a behaviour
 * change rather than a repaint.
 */
export const ANTD_BREAKPOINTS = {
  xs: '480px',
  sm: '576px',
  md: '768px',
  lg: '992px',
  xl: '1200px',
  xxl: '1600px'
} as const;

export type Breakpoints = typeof ANTD_BREAKPOINTS;

/**
 * Today's shell dimensions, and the switch-off side of every shell measurement. The new-design side
 * lives in `themes.constants` as `NEW_DESIGN_LAYOUT`.
 */
export const LEGACY_LAYOUT = {
  topBarHeight: '50px',
  navbarWidth: '220px',
  navbarCollapsedWidth: '50px',
  breadcrumbBarHeight: '35px',
  navbarTransitionDuration: '300ms'
} as const;

export type LayoutDimensions = Record<keyof typeof LEGACY_LAYOUT, string>;
